import Default from "./GroupedExpandable";
export * from "./GroupedExpandable";

export default Default;
